import type * as ecModels from '../../../models'

/**
 * {@link https://ngrx.io/docs State} of this plugin
 */
export interface State<
  TTypeParams extends ecModels.TypeParams = ecModels.TypeParams,
> {
  // TODO: nothing needed right now, but leaving so that we don't have to do a
  // big refactor if/when we need something here
}
export namespace State {
  export const INITIAL: State = {}
}
